var aptis = aptis || {};
aptis.virtualReality = aptis.virtualReality || {};
aptis.virtualReality.engine = aptis.virtualReality.engine || {};

var $j = $ || jQuery;
